import { parseUtcTimestamp } from "../services/dateTime";

/** Shared formatting helpers used across Batch/Dispatch/Analytics pages. */

export const formatDateTime = (value) => {
  const date = parseUtcTimestamp(value);
  if (!date) return "-";
  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatTime = (value, options = {}) => {
  const date = parseUtcTimestamp(value);
  if (!date) return "-";
  return date.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", ...options });
};

/** Minutes → "4h 10m" / "35m". */
export const formatMinutes = (minutes) => {
  if (minutes == null || Number.isNaN(minutes)) return "-";
  const hours = Math.floor(minutes / 60);
  const remaining = Math.round(minutes % 60);
  return hours > 0 ? `${hours}h ${remaining}m` : `${remaining}m`;
};
